export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12596.239d89c8.jpg";